import { render } from "./selected_details.vue?vue&type=template&id=234f4e15&scoped=true"
import script from "./selected_details.vue?vue&type=script&lang=js"
export * from "./selected_details.vue?vue&type=script&lang=js"

import "./selected_details.vue?vue&type=style&index=0&id=234f4e15&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234f4e15"]])

export default __exports__